export type CellStyle = {
  textAlign: 'left' | 'right' | 'center',
  'white-space'?: 'normal',
};

export const alignLeftCellStyle: { cellStyle: CellStyle } = {
  cellStyle: {
    textAlign: 'left',
  },
};

export const alignRightCellStyle: { cellStyle: CellStyle } = {
  cellStyle: {
    textAlign: 'right',
  },
};

export const alignCenterCellStyle: { cellStyle: CellStyle } = {
  cellStyle: {
    textAlign: 'center',
  },
};
